'use client';

import { Compass } from 'lucide-react';
import { usePathname } from 'next/navigation';
import { useTour } from '@/components/client/tour/TourContext';
import {
  buildSignedOutSharprTourSteps,
  tourSportFromPath,
} from '@/components/client/tour/tourSteps';
import { useSession } from '@/hooks/useSession';

/** Header trigger for the product walkthrough — signed-out only. Anonymous
 *  visitors are the primary tour audience (they don't know the product yet),
 *  so they keep a permanent header entry point. Signed-in users get the same
 *  affordance tucked inside the UserMenu dropdown to free up header space.
 *  Sport is derived from the current path so the first step lands on the
 *  page the user is already on. */
export function HeaderTourButton() {
  const tour = useTour();
  const pathname = usePathname();
  const sport = tourSportFromPath(pathname);
  const { user, loading } = useSession();

  if (loading || user) return null;

  return (
    <button
      type="button"
      onClick={() => {
        const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
        tour.start(buildSignedOutSharprTourSteps({ sport, isMobile }));
      }}
      title="Tour"
      aria-label="Tour"
      className="inline-flex items-center sm:gap-1.5 px-1.5 sm:px-2.5 h-8 sm:h-9 rounded-md text-muted-foreground dark:text-text-tertiary hover:text-fg dark:hover:text-text-primary hover:bg-hover dark:hover:bg-bg-overlay transition-colors"
    >
      <Compass className="w-4 h-4" />
      <span className="hidden sm:inline text-sm font-medium">Tour</span>
    </button>
  );
}
